// extracted by mini-css-extract-plugin
export default {"actions":"CompanyObjects_actions__BV03Z"};